import { useState } from 'react';
import Button from '@mui/material/Button';
import { useController } from 'react-hook-form';
import { Dialog, DialogContent } from '@mui/material';
import { TestAutocomplete } from './autoCompleteInputs/TestAutoCompleteInput';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import ExerciseCreate from '../../resources/exercise/ExerciseCreate';

const AddExerciseAutoComplete = (props: any) => {
    const i = useController({ name: props.source });
    const [createExercise, setCreateExercise] = useState(false);

    if (i.field.value && !props.multiple) {
        return (
            <div
                className={
                    'w-full p-4 rounded-md bg-gray-50 mb-4 border border-gray-200 flex justify-between items-center'
                }
            >
                <DocumentScannerIcon className={'text-black'} style={{ fontSize: '100px' }} />
                <Button
                    color={'error'}
                    onClick={() => {
                        i.field.onChange('');
                    }}
                >
                    Change Exercise
                </Button>
            </div>
        );
    }
    return (
        <div className={'w-full'}>
            {createExercise && (
                <Dialog
                    open={createExercise}
                    onClose={() => setCreateExercise(false)}
                    maxWidth="sm"
                    fullWidth
                >
                    <ExerciseCreate
                        onSuccess={(exerciseId: any) => {
                            if (props.multiple) {
                                const currentValue = i.field.value || [];
                                i.field.onChange([...currentValue, exerciseId]);
                            } else {
                                i.field.onChange(exerciseId);
                            }
                            setCreateExercise(false);
                        }}
                    />
                </Dialog>
            )}
            <>
                <div className={'flex justify-between items-center'}>
                    <div className={'text-xs text-gray-500'}>Search By Name</div>
                    <div
                        onClick={() => {
                            setCreateExercise(true);
                        }}
                        className={
                            'text-indigo-500 text-sm font-medium py-1 cursor-pointer px-2 hover:bg-indigo-50 transition-all duration-200 rounded'
                        }
                    >
                        Add a New Exercise
                    </div>
                </div>
                <TestAutocomplete
                    type={'EXERCISE'}
                    source={props.source || 'exerciseId'}
                    label={props.label || 'Exercise'}
                    multiple={props.multiple}
                />
            </>
        </div>
    );
};

export default AddExerciseAutoComplete;
